import ProductoService from "@/services/ProductoService.js";
import { Notify } from 'quasar';
import { ref } from "vue";
import { useAuthStore } from "@/stores/useAuthStore.js"


export function useImageUploader(form, props) {
    const { checkPermission } = useAuthStore();
    const image = ref(null);
    const random = ref(Math.random());
    const onImageChange = async (event) => {
        const file = event.target.files[0];
        if (file) {
            await imageUpload(props, file);
            random.value = Math.random(); // Update random value to force image reload
        }
    };

    const imageUpdate = () => {
        if (!checkPermission('producto.editar.imagen')) {
            return false
        }
        image.value.click()
    };
    const imageRemove = () => {
        form.imagen = null;
        image.value = null;
    };

    return {
        image,
        onImageChange,
        imageUpdate,
        imageRemove,
        random
    };
}

const imageUpload = async (props, file) => {
    const formData = new FormData();
    formData.append("imagen", file);
    formData.append(
        "productos",
        JSON.stringify([props.producto.productoID])
    );
    try {
        await ProductoService.image(formData);
    } catch (error) {
        console.error("Error uploading image:", error);
        throw error;
    }

}
